(function () {
  function trapOpen(scrim, panel, openAttr) {
    panel.setAttribute('aria-hidden', 'false');
    scrim.classList.add('on');
    panel.classList.add('on');
    document.documentElement.classList.add('no-scroll');
  }
  function trapClose(scrim, panel) {
    panel.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('on');
    panel.classList.remove('on');
    document.documentElement.classList.remove('no-scroll');
  }

  // Mobile menu drawer
  var menuScrim = document.querySelector('[data-menu-scrim]');
  var menuPanel = document.querySelector('[data-menu-panel]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]') && menuPanel) trapOpen(menuScrim, menuPanel);
    if ((e.target.closest('[data-menu-close]') || e.target === menuScrim) && menuPanel) trapClose(menuScrim, menuPanel);
  });

  // Search panel
  var searchScrim = document.querySelector('[data-search-scrim]');
  var searchPanel = document.querySelector('[data-search-panel]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]') && searchPanel) {
      trapOpen(searchScrim, searchPanel);
      var input = searchPanel.querySelector('[data-search-input]');
      if (input) setTimeout(function () { input.focus(); }, 50);
    }
    if ((e.target.closest('[data-search-close]') || e.target === searchScrim) && searchPanel) trapClose(searchScrim, searchPanel);
  });

  // Escape key closes any open overlay
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (menuPanel && menuPanel.classList.contains('on')) trapClose(menuScrim, menuPanel);
    if (searchPanel && searchPanel.classList.contains('on')) trapClose(searchScrim, searchPanel);
    var cartPanel = document.querySelector('[data-cart-panel]');
    var cartScrim = document.querySelector('[data-cart-scrim]');
    if (cartPanel && cartPanel.classList.contains('on')) trapClose(cartScrim, cartPanel);
    var popup = document.querySelector('[data-popup-card]');
    if (popup && popup.classList.contains('on')) popup.dispatchEvent(new Event('theme:popup-close'));
  });

  // Sticky header shadow on scroll
  var header = document.querySelector('[data-sticky-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 6); };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Rotating announcement bar
  var ann = document.querySelector('[data-announce]');
  if (ann) {
    var msgs = ann.querySelectorAll('.announce-msg');
    if (msgs.length > 1) {
      var i = 0;
      setInterval(function () {
        msgs[i].removeAttribute('data-active');
        i = (i + 1) % msgs.length;
        msgs[i].setAttribute('data-active', '');
      }, 4000);
    }
  }

  // Accordions (product description / specs / FAQ)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-accordion-trigger]');
    if (!t) return;
    var item = t.closest('[data-accordion-item]');
    var open = item.hasAttribute('data-open');
    item.toggleAttribute('data-open', !open);
  });

  window.themeTrapOpen = trapOpen;
  window.themeTrapClose = trapClose;
})();
